import { useEffect, useMemo, useState } from "react";
import { DESKTOP_MIN_WIDTH } from "@/constants";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions(): {
  mediaQuery: "mobile" | "desktop";
  width: number;
  height: number;
  isMobile: boolean;
  isDesktop: boolean;
} {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { mediaQuery, isMobile, isDesktop } = useMemo(
    () => viewportFor(windowDimensions.width),
    [windowDimensions.width],
  );

  return { ...windowDimensions, mediaQuery, isMobile, isDesktop };
}

/** Mobile or desktop for a window width: desktop from 768, where `md:` starts */
export function viewportFor(width: number) {
  if (width < DESKTOP_MIN_WIDTH) {
    return {
      mediaQuery: "mobile" as const,
      isMobile: true,
      isDesktop: false,
    };
  }
  return { mediaQuery: "desktop" as const, isMobile: false, isDesktop: true };
}
